/**
 * Recharts needs literal colour values, so the chart palette lives here — the
 * one place in the app allowed to hold hex. Values mirror the tokens in
 * src/index.css; change both together.
 */

export const CHART = {
  brand: '#6d5ee6',
  profit: '#3fb950',
  loss: '#f85149',
  info: '#58a6ff',
  warning: '#d29922',
  grid: '#202429',
  axis: '#7d828a',
  /** Categorical series, ordered for maximum separation. */
  series: ['#6d5ee6', '#58a6ff', '#3fb950', '#d29922', '#f85149', '#a99cff'],
} as const;

export const CHART_TOOLTIP = {
  backgroundColor: '#1c2025',
  border: '1px solid #2d3238',
  borderRadius: '8px',
  fontSize: '12px',
  color: '#f2f3f5',
  boxShadow: '0 8px 24px -6px rgb(0 0 0 / 0.55)',
  padding: '8px 10px',
} as const;

export const CHART_AXIS = {
  stroke: CHART.axis,
  fontSize: 11,
  axisLine: false,
  tickLine: false,
} as const;
